import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setFieldSettingsMediaFormat: YJSChangeHandler<
  DatabaseChangeType.SET_FIELD_SETTINGS_MEDIA_FORMAT
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];
    field.mediaFormat = change.mediaFormat;
  });
};
